import { ITab } from 'shared/components/buttons/tab-button/tab-button-interface';

export enum ShiftActivityTab {
  ALERTS = 'alerts',
  PROCESS_TYPES = 'process-types',
}

export const ShiftActivityTabs: ITab[] = [
  {
    label: 'Process Types',
    key: ShiftActivityTab.PROCESS_TYPES,
  },
  {
    label: 'Alerts',
    key: ShiftActivityTab.ALERTS,
  },
];
